/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * AI agent service type
 */
export type UpdateAiAgentServiceSettingInputServiceType =
  (typeof UpdateAiAgentServiceSettingInputServiceType)[keyof typeof UpdateAiAgentServiceSettingInputServiceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAiAgentServiceSettingInputServiceType = {
  invoice_download_agent: 'invoice_download_agent',
  payment_request_ocr_support_agent: 'payment_request_ocr_support_agent',
  payment_request_support_agent: 'payment_request_support_agent',
} as const;
